import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { GetFeaturesResponse } from "@/types/features";

import { getFeatures } from "./featuresApi";

export const useGetFeaturesAPI = (
  query: string | null = null,
  options?: Omit<
    UseQueryOptions<GetFeaturesResponse, Error, GetFeaturesResponse>,
    "queryKey" | "queryFn"
  >
) =>
  useQuery({
    queryKey: ["getFeatures", query],
    queryFn: () => getFeatures(query),
    ...options
  });
